/* eslint-disable */
import commonObj from "../commonObj";

class util {
  checkRightAccess = (key) => {
    if (!key) {
      return commonObj.userType === "superAdmin";
    }
    if (typeof key === "string") {
      return (
        commonObj.userType === "superAdmin" ||
        commonObj?.adminRights?.includes(key)
      );
    }
  };

  setUserData = (data) => {
    try {
      let token = null;
      let user = null;
      let role = null;

      // if (data.accessToken) {
      //   token = data.accessToken;
      // } else if (data.data?.token) {
      //   token = data.data.token;
      // } else if (data.access_token) {
      //   token = data.access_token;
      // } else if (data.auth_token) {
      //   token = data.auth_token;
      // }

      // Handle your actual response: { data: { data: { accessToken, user } } }
      if (data?.data?.data?.accessToken) {
        token = data.data.data.accessToken;
        user = data.data.data.user;
        role = data.data.data.user?.role;
      }
      // Backward compatibility (old formats)
      else if (data?.data?.accessToken) {
        token = data.data.accessToken;
        user = data.data.user;
        role = data.data.user?.role;
      } else if (data?.accessToken) {
        token = data.accessToken;
        user = data.user;
        role = data.user?.role;
      } else if (data?.token) {
        token = data.token;
      }

      if (token) {
        const tokenValue = token.startsWith("Bearer ") ? token : `${token}`;
        window.localStorage.setItem("authorization", tokenValue);

        if (user) {
          window.localStorage.setItem("user", JSON.stringify(user));
        }
        if (role) {
          window.localStorage.setItem("type", role);
        }

        if (type) {
          window.localStorage.setItem("type", userType);
        }

        //keep only this console
        // console.log(" Token saved:", tokenValue.substring(0, 20) + "...");

        // if (data.user) {
        //   window.localStorage.setItem("user", JSON.stringify(data.user));
        // } else if (data.data?.user) {
        //   window.localStorage.setItem("user", JSON.stringify(data.data.user));
        // }

        // if (data.user) {
        //   window.localStorage.setItem("type", data.user.role);
        // } else if (data.userType) {
        //   window.localStorage.setItem("type", data.userType);
        // }
      }
    } catch (error) {
      // fail silently
    }
  };

  setShipRocketApiUserData = (data) => {
    window.localStorage.removeItem("ship-authorization");
    window.localStorage.setItem("ship-authorization", data.token);
  };

  getUserData = ($key) => {
    try {
      const userData = window.localStorage.getItem("user");
      if (!userData) {
        return null;
      }
      const parsedUser = JSON.parse(userData);
      return $key ? parsedUser[$key] : parsedUser;
    } catch (error) {
      return null;
    }
  };

  setUserType = (data = "") => {
    window.localStorage.setItem("type", data);
  };

  userType = () => {
    return window.localStorage.getItem("type");
  };

  getToken = () => {
    return window.localStorage.getItem("authorization") || "";
  };

  getShipToken = () => {
    return window.localStorage.getItem("ship-authorization") || "";
  };

  isLogged = () => {
    const token = window.localStorage.getItem("authorization");
    return !!(token && token !== "undefined" && token.trim() !== "");
  };

  logout = (e) => {
    if (e) e.preventDefault();
    window.localStorage.removeItem("authorization");
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("type");
    window.localStorage.removeItem("token_expires");
    sessionStorage.removeItem("msgShown");
    window.location.reload();
  };

  setTheme($theme = "light") {
    window.localStorage.setItem("theme", $theme);
    return $theme;
  }

  getTheme() {
    return window.localStorage.getItem("theme");
  }

  removeSpecialChars(key) {
    return key
      ?.trim()
      .toLowerCase()
      ?.replace(/[^a-z0-9 _-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  handleInteger($str, $len = 10) {
    let num = $str?.replace(/[^0-9]/g, "");
    return $len ? num?.substring(0, $len) : num;
  }

  handleFloat(value, maxValue) {
    value = value.replace(/[^0-9.]/g, "");
    let newValue = value.replace(/[\.\%]/g, function (match, offset, all) {
      return match === "." ? (all.indexOf(".") === offset ? "." : "") : "";
    });
    if (maxValue && newValue * 1 > maxValue * 1) {
      newValue = maxValue;
    }
    return newValue;
  }

  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  queryStringToJSON(qs) {
    qs = qs || window.location.search.slice(1);
    if (qs.charAt(0) === "?") {
      qs = qs.slice(1);
    }

    var pairs = qs.split("&");
    var result = {};
    pairs.forEach(function (p) {
      var pair = p.split("=");
      var key = pair[0];
      var value = decodeURIComponent(pair[1] || "");
      if (result[key]) {
        if (Object.prototype.toString.call(result[key]) === "[object Array]") {
          result[key].push(value);
        } else {
          result[key] = [result[key], value];
        }
      } else {
        result[key] = value;
      }
    });

    return JSON.parse(JSON.stringify(result));
  }

  getFileFormat(data) {
    if (data.url && data.uid) {
      return [data];
    }
    if (typeof data === "string") {
      const name = data.split("/").pop();
      return [
        {
          uid: name.split(".")[0],
          url: data,
        },
      ];
    }
    if (Array.isArray(data)) {
      return data.map((v) => {
        if (v?.uid && v?.url) {
          return v;
        } else {
          const name = v.split("/").pop();
          return {
            uid: name.split(".")[0],
            url: v,
          };
        }
      });
    }
  }

  convertToCommaSeperatedValue(number = "0") {
    const reversedNumber = number.toString().split("").reverse().join("");
    const parts = reversedNumber.match(/.{1,3}/g);
    const formatedNumber = parts.join(",");
    return formatedNumber.split("").reverse().join("");
  }
}

export default new util();
